/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function showTitle(params) {
    var formatInput = function () { return ({
        fullScreenV2: 'NO',
        fullScreen: 'NO', // 传值为YES时，当前H5容器全屏，其他值则不全屏
    }); };
    // https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
    WVCall('CNHybridH5ParamUtil.handleH5Param', params, { formatInput: formatInput });
}

export { showTitle as default };
